import { autoUpdate, offset, useFloating } from "@floating-ui/react-dom";
import React, { useContext, useEffect, useState } from "react";
import { RicosContext, ZIndexContext } from "./../ricos-context/index.js";
import { FocusManager } from ".//focus-manager/focus-manager.js";
import { ClickOutside, UiComponentsProvider } from "./../ui-components/index.js";
const FloatingContainer = ({
  children,
  modalConfig,
  state,
  editorContainer,
  onClickOutside
}) => {
  const { jsdomMode } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  const [modalElement, setModalElement] = useState(null);
  const { autoFocus = true, positioning } = modalConfig || {};
  const referenceElement = positioning?.referenceElement;
  const middlewares = modalConfig?.positioning?.placement === "bottom" ? [] : [
    offset({
      mainAxis: (referenceElement?.getBoundingClientRect()?.height ?? 0) * -1 - 10,
      crossAxis: 0
    })
  ];
  const {
    x,
    y,
    refs: { setReference, setFloating },
    strategy
  } = useFloating({
    placement: "bottom-start",
    strategy: "fixed",
    middleware: middlewares,
    whileElementsMounted: (referenceEl, floatingEl, update) => autoUpdate(referenceEl, floatingEl, update, {
      animationFrame: true
    })
  });
  useEffect(() => {
    setReference(referenceElement);
  }, [setReference, referenceElement]);
  const isVisible = jsdomMode || Boolean(x || y) || state === "top";
  const escToClickOutside = (e) => {
    if (e.key === "Escape") {
      onClickOutside(e);
      return;
    }
  };
  const editorRect = editorContainer.getBoundingClientRect();
  const content = (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: (ref) => {
          setFloating(ref);
          setModalElement(ref);
        },
        onKeyDown: escToClickOutside,
        style: {
          ...state === "top" || modalConfig?.positioning?.placement === "top" ? {
            top: 55,
            left: editorRect.left,
            width: editorRect.width,
            position: "fixed"
          } : {
            top: y ?? "",
            left: (x ?? 0) + 10,
            width: referenceElement?.getBoundingClientRect()?.width ? referenceElement.getBoundingClientRect().width - 20 : "auto",
            position: strategy
          },
          zIndex: zIndexService.getZIndex("DIALOG"),
          display: "block",
          visibility: isVisible ? "visible" : "hidden",
          transition: state === "top" ? "top 0.2s ease, left 0.2s ease, width 0.2s ease" : void 0
        }
      },
      modalElement && /* @__PURE__ */ React.createElement(UiComponentsProvider, { containerEl: modalElement }, children)
    )
  );
  return /* @__PURE__ */ React.createElement(
    ClickOutside,
    {
      onClickOutside,
      triggerOn: typeof modalConfig?.onClickOutside !== "function" ? modalConfig?.onClickOutside?.on : void 0
    },
    autoFocus ? /* @__PURE__ */ React.createElement(
      FocusManager,
      {
        focusTrapOptions: {
          returnFocusOnDeactivate: false,
          fallbackFocus: document.activeElement
        },
        jsdomMode,
        active: isVisible,
        preventScroll: true
      },
      content
    ) : content
  );
};
export {
  FloatingContainer
};
//# sourceMappingURL=floating-container.js.map
